module.exports = __webpack_public_path__ + "img/_cod.f614f807.svg";